var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "제품 및 솔루션",
      "sc": "에프원시큐리티는 다방면으로 파트너의 정보를 보호합니다",
      "tabActive": "F1 WEBCASTLE",
      "icon": "/images/sub/visual/sv3-icon.svg",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section-sm sub-section-sm--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title mb-32 mb-lg-56"
  }, [_c('h3', {
    staticClass: "sub-tit--lg text-center mb-30 mb-lg-44",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 웹 방화벽 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" Web Application Firewall (WAF)이란? ")]), _c('p', {
    staticClass: "sub-tit--sm mb-12 mb-lg-22 text-center"
  }, [_vm._v(" 네트워크 방화벽(Firewall)과는 달리 웹 애플리케이션 보안에 특화되어, SQL Injection, XSS등이라 불리는 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 웹사이트나 서버에 대한 공격들을 탐지하고 대응 및 차단하는 보안 방식입니다. ")]), _c('p', {
    staticClass: "sub-tit--sm mb-12 mb-lg-22 text-center"
  }, [_vm._v(" 기존의 웹 공격 대응 기능 외에도, 정보유출방지, 부정접근차단, 파일 등의 위변조 방지 등의 기능을 수행합니다. "), _c('br'), _vm._v(" 웹 어플리케이션 방어에 특화 개발되어 있어, 웹 보안 취약점의 노출방지 및 악성코드가 외부에서 업로드되는 것을 차단합니다. "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" (웹취약점 노출 방지는 원래 웹스캐너, 시큐어코딩의 기능입니다.) ")])]), _c('v-row', [_c('v-col', {
    staticClass: "mb-20 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "radius-lg bg-grey h-100"
  }, [_c('p', {
    staticClass: "w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14"
  }, [_vm._v(" Appliance 기반의 웹 방화벽 (Hardware) ")]), _c('div', {
    staticClass: "pa-16 pt-md-22 pb-md-80 px-md-42"
  }, [_c('v-img', {
    staticClass: "d-block mb-28 mb-lg-48",
    attrs: {
      "max-width": "498",
      "src": "/images/sub/products/web/s1-img1.png"
    }
  }), _c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm mb-6 mb-lg-16"
  }, [_vm._v(" · Appliance 방식 ")]), _c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm mb-6 mb-lg-16"
  }, [_vm._v(" · 다른 보안 제품과 같이 독립적인 Box 형태 ")]), _c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm mb-6 mb-lg-16"
  }, [_vm._v(" · 시간당 트래픽 처리 용량으로 성능이 구분됨 ")]), _c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm"
  }, [_vm._v(" · 웹 서버 앞단에 위치하며 복수의 웹 서버 존재시 L4스위치 앞단에 위치 ")])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "radius-lg bg-grey h-100"
  }, [_c('p', {
    staticClass: "w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14"
  }, [_vm._v(" Software 기반의 웹 방화벽 (Software) ")]), _c('div', {
    staticClass: "pa-16 pt-md-22 pb-md-80 px-md-42"
  }, [_c('v-img', {
    staticClass: "d-block mb-28 mb-lg-48",
    attrs: {
      "max-width": "498",
      "src": "/images/sub/products/web/s1-img2.png"
    }
  }), _c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm mb-6 mb-lg-16"
  }, [_vm._v(" · 웹 보안 filter방식 ")]), _c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm mb-6 mb-lg-16"
  }, [_vm._v(" · 웹 서버에 직접 탑재하는 소프트웨어 방식 ")]), _c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm mb-6 mb-lg-16"
  }, [_vm._v(" · 웹 방화벽의 성능은 웹 서버의 용량에 의해 결정 되어짐 ")]), _c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm"
  }, [_vm._v(" · 웹 방화벽 설치 시, 기존 네트워크 구성에는 변화가 없음 ")])], 1)])])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section-sm"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--md text-center mb-26 mb-lg-42",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 웹 방화벽(WAF) 방식의 비교 ")]), _c('v-row', [_c('v-col', {
    staticClass: "mb-20 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "radius-lg bg-grey h-100"
  }, [_c('p', {
    staticClass: "w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14"
  }, [_vm._v(" 클라우드 전용 웹 방화벽 (Software) ")]), _c('div', {
    staticClass: "pa-16 pb-0 px-md-42 pt-md-70"
  }, [_c('v-img', {
    staticClass: "d-block mx-auto",
    attrs: {
      "max-width": "469",
      "src": "/images/sub/products/web/s2-img1.png"
    }
  })], 1), _c('div', {
    staticClass: "pa-16 px-md-40 pt-md-40 px-lg-70 pt-lg-70 pb-md-100"
  }, [_c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm mb-6 mb-lg-16"
  }, [_vm._v(" · 웹 서버에 위치하여 서버의 내부 자원인 CPU(3%이하), "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 최소한의 서버 리소스 이용 ")]), _c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm mb-6 mb-lg-16"
  }, [_vm._v(" · 웹 서버에서 한번의 Connection 으로 Request Data 검사, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 프로세스 처리, Response Data에 대한 검사함으로써 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 웹 방화벽 기능으로 인한 웹 서비스 응답 속도의 지연 현상을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 최소화 ")]), _c('p', {
    staticClass: "page-text-sm color-gray dot-txt-sm"
  }, [_vm._v(" · SSL(secure sockets layer) 트래픽도 평문 트래픽과 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 동일하게 처리 ")])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "radius-lg bg-grey h-100"
  }, [_c('p', {
    staticClass: "w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14"
  }, [_vm._v(" VM 기반의 웹 방화벽 (Hardware) ")]), _c('div', {
    staticClass: "pa-16 pb-0 px-md-42 pt-md-70"
  }, [_c('v-img', {
    staticClass: "d-block mx-auto",
    attrs: {
      "max-width": "469",
      "src": "/images/sub/products/web/s2-img2.png"
    }
  })], 1), _c('div', {
    staticClass: "pa-16 px-md-40 pt-md-40 px-lg-70 pt-lg-70 pb-md-100"
  }, [_c('div', {
    staticClass: "dot-txt-sm mb-8 mb-lg-24"
  }, [_c('p', {
    staticClass: "page-text-sm color-gray mb-4 mb-lg-10"
  }, [_vm._v(" · 다수의 웹 서버 앞 단에 위치하는 웹 방화벽은 트래픽 부하 이슈 ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 color-gray bar-txt line-height-15"
  }, [_vm._v(" - 웹 방화벽에서 Request Data에 대한 해킹 검사를 위한 Connection ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 color-gray bar-txt line-height-15"
  }, [_vm._v(" - 웹 서버에서 프로세스 처리를 위한 Connectio ")]), _c('div', {
    staticClass: "bar-txt"
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-16 color-gray line-height-15"
  }, [_vm._v(" - 웹 방화벽에서 Response Data에 대한 검사를 위한 Connection ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 color-gray arrow-txt line-height-15"
  }, [_vm._v(" → 하나의 Process에 4번의 Connection이 발생하여 웹 서비스 속도 저하 현상이 발생 ")])])]), _c('div', {
    staticClass: "dot-txt-sm"
  }, [_c('p', {
    staticClass: "page-text-sm color-gray mb-4 mb-lg-10"
  }, [_vm._v(" · 시간당 처리능력에 따라 네트워크 별로 별도 구성되어야 함 ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 color-gray bar-txt line-height-15"
  }, [_vm._v(" - 네트워크 구성이 복잡해짐 ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 color-gray bar-txt line-height-15"
  }, [_vm._v(" - 갑작스런 트래픽 증가에 따른 네트워크 상의 문제가 발생 ")])])])])])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section-sm sub-section--last"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--md text-center mb-26 mb-lg-42",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 시장에서 검증된 F1-WEBCastle의 주요 기능 ")]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-md border-light h-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "py-28 py-lg-40 d-flex justify-center"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "65",
      "src": "/images/sub/products/web/s3-icon1-1.png"
    }
  })], 1), _c('p', {
    staticClass: "text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12"
  }, [_vm._v(" 보안관제 및 통합관리 ")]), _c('div', {
    staticClass: "pa-16 pa-md-24"
  }, [_c('p', {
    staticClass: "color-gray text-center page-text-sm"
  }, [_vm._v(" 관리자가 동일한 UI화면에서 다수의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 웹 서버 현황 및 사이버 공격을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 실시간으로 파악할 수 있으며, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 전체적인 통계를 한눈에 파악할 수 있는 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 대시보드를 제공합니다. ")])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-md border-light h-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "400"
    }
  }, [_c('div', {
    staticClass: "py-28 py-lg-40 d-flex justify-center"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "65",
      "src": "/images/sub/products/web/s3-icon1-2.png"
    }
  })], 1), _c('p', {
    staticClass: "text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12"
  }, [_vm._v(" 중앙서버 - 에이전트 간 접속보안관리 ")]), _c('div', {
    staticClass: "pa-16 pa-md-24"
  }, [_c('p', {
    staticClass: "color-gray text-center page-text-sm"
  }, [_vm._v(" 중앙 서버 관리자와 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 웹캐슬 에이전트 간에 주고받는 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 트래픽을 SSL로 암호화하여 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 중간에 도청할 수 없도록 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 보안 기능을 제공합니다. ")])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-md border-light h-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "700"
    }
  }, [_c('div', {
    staticClass: "py-28 py-lg-40 d-flex justify-center"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "65",
      "src": "/images/sub/products/web/s3-icon1-3.png"
    }
  })], 1), _c('p', {
    staticClass: "text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12"
  }, [_vm._v(" 일관된 보안정책설정 ")]), _c('div', {
    staticClass: "pa-16 pa-md-24"
  }, [_c('p', {
    staticClass: "color-gray text-center page-text-sm"
  }, [_vm._v(" 회사별, 그룹별로 보안정책에 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 따른 일관된 보안정책 설정, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 접속을 통제하거나 위협요소를 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 차단할 수 있는 보안관리 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 기능을 제공합니다. ")])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-md border-light h-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "1000"
    }
  }, [_c('div', {
    staticClass: "py-28 py-lg-40 d-flex justify-center"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "65",
      "src": "/images/sub/products/web/s3-icon1-4.png"
    }
  })], 1), _c('p', {
    staticClass: "text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12"
  }, [_vm._v(" SSL 적용시 성능저하 없는 탐지 · 방어 솔루션 ")]), _c('div', {
    staticClass: "pa-16 pa-md-24"
  }, [_c('p', {
    staticClass: "color-gray text-center page-text-sm"
  }, [_vm._v(" 개정된 개인정보보호법에 따른 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 안전한 웹통신을 위해 SSL "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" (Secure Socket Layer) 사용률 급증 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" / SSL Traffic을 이용한 웹 공격 대응 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 및 방어 시에 성능저하가 없습니다. ")])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-md border-light h-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "1300"
    }
  }, [_c('div', {
    staticClass: "py-28 py-lg-40 d-flex justify-center"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "65",
      "src": "/images/sub/products/web/s3-icon1-5.png"
    }
  })], 1), _c('p', {
    staticClass: "text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12"
  }, [_vm._v(" 세분화된 로그관리 ")]), _c('div', {
    staticClass: "pa-16 pa-md-24"
  }, [_c('p', {
    staticClass: "color-gray text-center page-text-sm"
  }, [_vm._v(" 보안정책에 따른 관리자 및 공격자에 대한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 로그인 기록, 이용기록, 이력관리, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 탐지 및 차단 이력 등 관련된 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 전체 로그가 남아 문제가 발생시 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 선제 대응할 수 있습니다. ")])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-md border-light h-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "1600"
    }
  }, [_c('div', {
    staticClass: "py-28 py-lg-40 d-flex justify-center"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "65",
      "src": "/images/sub/products/web/s3-icon1-6.png"
    }
  })], 1), _c('p', {
    staticClass: "text-center font-weight-bold border-top border-bottom border-color-light bg-grey color-point page-text-sm pa-12"
  }, [_vm._v(" 원격지 통합보안관리 ")]), _c('div', {
    staticClass: "pa-16 pa-md-24"
  }, [_c('p', {
    staticClass: "color-gray text-center page-text-sm"
  }, [_vm._v(" 인터넷만 연결이 되어있으면 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 국내외 어느 곳에 위치한 웹 서버라도 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 온라인으로 설치 및 운영이 가능하며, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 보안정책에 따라 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 통합보안관리가 가능합니다. ")])])])])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }